import type { QuoteDocument } from 'paintscout'
export function isQuoteEditable(quote: QuoteDocument) {
  let isEditable = true
  if (quote?.archived) {
    isEditable = false
  } else if (quote?.status?.value !== 'draft') {
    isEditable = false
  }

  return isEditable
}
